if(showTicker == true){
    /**
     * ticker UI position based on sticky CTA
     */
    function isInViewport(el) {
        const rect = el.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    document.addEventListener('scroll', function () {
        const ticker = $('.ticker--topLeft');
        
        if (ticker.length) {
            const header = document.querySelector('header');
            const surveyQuestionBanner = document.querySelector('#surveyQuestionBanner');

            //- Position combinations - With / Without header; With / Without surveyQuestionBanner
            let tickerTopPos = 15;
            let tickerHeaderTopPos = 90; 
            let surveyQuestionBannerHeight, tickerHeaderSurveyQuestionBannerHeight, tickerSurveyQuestionBannerHeight;

            if ($(surveyQuestionBanner).length) {
                surveyQuestionBannerHeight = Math.floor(surveyQuestionBanner.getBoundingClientRect().height);
                tickerHeaderSurveyQuestionBannerHeight = tickerHeaderTopPos + surveyQuestionBannerHeight;
                tickerSurveyQuestionBannerHeight =  tickerTopPos + surveyQuestionBannerHeight;
            }

            // console.log(isInViewport(header));
            // console.log(isInViewport(surveyQuestionBanner));
            // console.log(tickerTopPos + 'px');
            // console.log(tickerHeaderTopPos + 'px');
            // console.log(surveyQuestionBannerHeight + 'px');
            // console.log(tickerHeaderSurveyQuestionBannerHeight + 'px');
            // console.log(tickerSurveyQuestionBannerHeight + 'px');

            if (isInViewport(header) == true) {
                if ($(surveyQuestionBanner).length) {
                    if(isInViewport(surveyQuestionBanner) == false) {
                        document.documentElement.style.setProperty('--tickerTopPos', tickerHeaderTopPos + 'px');
                    } else {
                        document.documentElement.style.setProperty('--tickerTopPos', tickerHeaderSurveyQuestionBannerHeight + 'px');
                    }
                } else {
                    document.documentElement.style.setProperty('--tickerTopPos', tickerHeaderTopPos + 'px');
                }
                

            } else {
                if ($(surveyQuestionBanner).length) {
                    if(isInViewport(surveyQuestionBanner) == false || surveyQuestionBannerHeight == 0) {
                        document.documentElement.style.setProperty('--tickerTopPos', tickerTopPos + 'px');
                    } else {
                        document.documentElement.style.setProperty('--tickerTopPos', tickerSurveyQuestionBannerHeight + 'px');
                    }
                } else {
                    document.documentElement.style.setProperty('--tickerTopPos', tickerTopPos + 'px');
                }
            }

        }

        //- change Reviews Banner Component to fixed position when arrived to top
        const reviewsComponent = $('#reviewsBanner');
        
        if (reviewsComponent.length) {            
            const bannerComponent = document.querySelector('.reviewsBanner');
            const topElement = document.querySelector('#viewportDetector');

            let bannerComponentHeight = bannerComponent.clientHeight + 30 + 'px';

            // console.log('bannerComponent ' + isInViewport(bannerComponent));
            // console.log('topElement ' + isInViewport(topElement));
            // console.log('bannerComponentHeight ' + bannerComponentHeight);

            if (isInViewport(bannerComponent) == false) {
                bannerComponent.classList.add('fixed');

                document.documentElement.style.setProperty('--iconMarginTop', bannerComponentHeight);
            }

            if (isInViewport(topElement) == true) {
                bannerComponent.classList.remove('fixed');

                document.documentElement.style.setProperty('--iconMarginTop', '15px');
            }
        }
    });

    /**
     * Ticker 
     */
    let counter;

    // recentlyBought();
    function recentlyBought() {
        const ticker = $('#ticker');
        const purchaseBox = $('#purchaseBox');
        counter = 0;

        // storage returned strings from getPurchases(), passing provided purchases array
        let purchasesArray = getPurchases(purchases);

        // console.log(purchasesArray.length); //- 300

        function appendRecentlyBought(item) {
            purchaseBox.html(item); //- change text of purchaseBox with delay of 9s
        }

        function animateTicker() {
            appendRecentlyBought(purchasesArray[counter]);

            // console.log('For item = ' + counter + ': ' + purchasesArray[counter]);

            ticker.addClass('anim-in').delay(3000).queue(function () {
                $(this).removeClass('anim-in').dequeue();

                counter++;

                // Reset counter when reach the end
                if (counter >= purchasesArray.length) {
                    counter = 0;
                }

                let delayTime = (Math.floor((Math.random() * ((12 - 5) + 1) + 5)) * 1000);

                // console.log('delayTime = ' + delayTime);

                setTimeout(function () {
                    animateTicker();
                }, delayTime);
            })
        }

        animateTicker();
    }

    setTimeout(function () {
        recentlyBought()
    }, 4000);
}
